import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-annex-imported-badge',
  templateUrl: './annex-imported-badge.component.html',
  styleUrls: ['./annex-imported-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, MatTooltipModule, TranslateModule],
})
export class AnnexImportedBadgeComponent {
  @Input() visible: boolean = true;
}
